/**
 *
 */
export function getOrganizations() {
  return axios.get('/api/organizations');
}

/**
 *
 * @param data
 */
export function createOrganizations(data) {
  return axios.post('/api/organizations', data);
}

/**
 *
 * @param id
 * @param data
 */
export function updateOrganization(id, data) {
  return axios.put(`/api/organizations/${id}`, data);
}

/**
 *
 * @param id
 */
export function deleteOrganization(id) {
  return axios.delete(`/api/organizations/${id}`);
}

/**
 *
 * @param id
 */
export function getOrganizationInfo(id) {
  return axios.get(`/api/organizations/${id}`);
}

/**
 *
 * @param params
 */
export function getRegions(params) {
  return axios.get('/api/organizations/' + params.organizationId + '/regions');
}

/**
 *
 * @param id
 */
export function getRegionInfo(id) {
  return axios.get(`/api/regions/${id}`);

}

/**
 *
 * @param params
 */
export function getBranches(params) {
  return axios.get('/api/organizations/' + params.organizationId + '/regions/' + params.regionId + '/branches');
}

/**
 *
 * @param organizationId
 */
export function getManagers(organizationId) {
  return axios.get('/api/organizations/' + organizationId + '/managers');
}

/**
 *
 * @param organizationId
 * @param data
 */
export function createManager(organizationId, data) {
  const formData = new FormData();

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      formData.append(key, data[key]);
    }
  }

  return axios.post(`/api/organizations/${organizationId}/managers`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  // return axios.post(`/api/organizations/${organizationId}/managers`, data)
}

/**
 *
 * @param managerId
 */
export function getManager(managerId) {
  return axios.get(`/api/managers/${managerId}`);
}

/**
 *
 * @param managerId
 * @param data
 */
export function updateManager(managerId, data) {
  const formData = new FormData();

  formData.append('_method', 'PUT');

  for (const key in data) {
    if (data.hasOwnProperty(key) && data[key] !== null) {
      formData.append(key, data[key]);
    }
  }

  return axios.post(`/api/managers/${managerId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  // return axios.put(`/api/managers/${managerId}`, data)
}

/**
 *
 * @param managerId
 */
export function deleteManager(managerId) {
  return axios.delete(`/api/managers/${managerId}`);
}
